import type { CreateSite, Site } from '../site/site.interface';
import { SITE_TYPE } from '../site/site.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class SiteFactory extends ObjectFactory<Site> {
  protected getDefaults(): Site {
    return {
      ...baseDocumentFactory.build(),
      code: 'SITE-01',
      color: '#FF5733',
      name: 'Main Shop',
      spaceId: 'space-id',
      type: SITE_TYPE.SHOP,
    };
  }

  /** Build a CreateSite body (no base document fields). */
  buildCreate(overrides: Partial<CreateSite> = {}): CreateSite {
    return {
      code: 'SITE-01',
      color: '#FF5733',
      name: 'Main Shop',
      spaceId: 'space-id',
      type: SITE_TYPE.SHOP,
      ...overrides,
    };
  }
}

export type { Site };
export const siteFactory = new SiteFactory();
